import { Text, Fade, Box, Center } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from 'wg-fe-ui';

const GeneratingOffer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();

  return (
    <Center
      position="absolute"
      w="100%"
      h="100%"
      data-test-id="ADVISORY-CONVO_OFFERS_SIGNED-OFFERS_GENERATING-WRAPPER"
    >
      <Center
        flexDir={{ base: 'column', mobileL: 'row' }}
        zIndex="2"
        bg="white"
        p="4"
        m="4"
        borderRadius="sm"
      >
        <Box
          mr={{ base: 0, mobileL: '8' }}
          mb={{ base: '4', mobileL: 0 }}
          w="8"
          h="8"
          sx={{
            '> svg': {
              width: ' 100%',
              height: 'auto',
              minWidth: 'initial',
              minHeight: 'initial',
              transformOrigin: 'initial',
              circle: {
                strokeWidth: '5px',
              },
            },
          }}
        >
          <LoadingSpinner />
        </Box>
        <Text textStyle="largeBody">{t('Offer is being generated')}</Text>
      </Center>

      <Fade in unmountOnExit>
        <Box
          bg="rgba(34, 34, 34, 0.7)"
          backdropFilter="blur(10px)"
          w="100%"
          h="100%"
          position="absolute"
          left="0"
          top="0"
          zIndex="1"
        />
      </Fade>
    </Center>
  );
};

export default GeneratingOffer;
